import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import type { StatsDTO } from "@shared/types";

export function useStats(refreshKey: unknown) {
  const [stats, setStats] = useState<StatsDTO | null>(null);

  const reload = useCallback(async () => {
    try {
      setStats(await api.stats());
    } catch {
      /* non-critical */
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload, refreshKey]);

  return { stats, reload };
}
